import React from 'react';
import * as imageUtil from '@umu/umu-image-handle';


interface IProps {
    imgSrc: string;
    className: string;
    styleOption?: React.CSSProperties;
    onClick?: () => void;
}

export const Icon = (props: IProps) => {
    return (
        <div className={props.className} onClick={props.onClick}>
            <img src={imageUtil.appendWidth(props.imgSrc)} style={props.styleOption} className='micro-icon-img'/>
        </div>
    );
}
